
import Vue from "vue"
import { BootstrapVue, IconsPlugin, LayoutPlugin, ButtonPlugin, BTabs } from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "vue-context/dist/css/vue-context.css"
import BootstrapVueTreeview from "bootstrap-vue-treeview"
import LiquorTree from "liquor-tree"
import vSelect from "vue-select"
import VueLocalStorage from "vue-localstorage"
import VueQueryBuilder from "./third_party/vue-query-builder/VueQueryBuilder.vue"
import VueContext from "vue-context"
import VueClipboard from "vue-clipboard2"
import VueSlider from "vue-slider-component"
import * as MathLive from "mathlive/dist/mathlive.min.mjs"
import VueMathfield from "mathlive/dist/vue-mathlive.mjs"
import VModal from "vue-js-modal"
import vue_cookies from "vue-cookies"
import App from "./App.vue"
import router from "./router"
import date_picker from "./components/widgets/date_picker"
import BFormInput from "./components/b-form-input"
import "vue-select/dist/vue-select.css"
import "vue-slider-component/theme/default.css"
import "mathlive/dist/mathlive-static.css"
import InputColorPicker from "vue-native-color-picker"
import datetime_picker from "vue-bootstrap-datetimepicker"
import resize from "vue-element-resize-detector"
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css"
import "@fortawesome/fontawesome-free/css/all.css"
import VueFullscreen from 'vue-fullscreen'
import api from "./api"
import BaseIcon from './components/BaseIcon'

const VueInputMask = require("vue-inputmask").default

Vue.use(BootstrapVue,
	{
		BFormDatepicker :
		{
			"labelNoDateSelected" : "Дата не выбрана",
		},
	})

Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(ButtonPlugin)
Vue.use(BootstrapVueTreeview)
Vue.use(LiquorTree)
Vue.use(VueLocalStorage)
Vue.use(VueQueryBuilder)
Vue.use(VueInputMask)
Vue.use(VueContext)
Vue.use(VueClipboard)
Vue.use(VueMathfield, MathLive)
Vue.use(VModal, { dialog : true })
Vue.use(InputColorPicker)
Vue.use(datetime_picker)
Vue.use(resize)
Vue.use(VueFullscreen)
Vue.use(vue_cookies)

Vue.component("v-query", VueQueryBuilder)
Vue.component("v-context-menu", VueContext)
Vue.component("v-slider", VueSlider)
Vue.component("v-color-picker", InputColorPicker)
Vue.component("datetime_picker", datetime_picker)
Vue.component("date_picker", date_picker)
Vue.component('base-icon', BaseIcon)
Vue.component('b-form-input', BFormInput)

var appendToBody =
{
	inserted(el, bindings, { context })
	{
		if (context.appendToBody)
		{
			const { height, top, left, width, } = context.$refs.toggle.getBoundingClientRect()

			if(context.$attrs.appendToParent == null)
			{
				let scrollX = window.scrollX || window.pageXOffset
				let scrollY = window.scrollY || window.pageYOffset

				el.unbindPosition = context.calculatePosition(el, context,
					{
						width: width + "px",
						left: scrollX + left + "px",
						top: scrollY + top + height + "px",
					})

				document.body.appendChild(el)
			}
			else
			{
				el.unbindPosition = context.calculatePosition(el, context,
					{
						width: width + "px",
						left: left + "px",
						top: top + height + "px",
					})

				el.style.position = "fixed"
				context.$parent.$el.appendChild(el)
			}
		}
	},

	unbind(el, bindings, { context })
	{
		if (context.appendToBody)
		{
			if (el.unbindPosition && typeof el.unbindPosition === "function")
				el.unbindPosition()

			if (el.parentNode)
				el.parentNode.removeChild(el)
		}
	},
}

import OpenIndicator from './components/vSelect/openIndicator'

vSelect.props.components.default = () => ({ OpenIndicator, Option })

var replace_no_options_mixin = 
{
	mounted()
	{
		if (this.$attrs.state === false)
		{
			this.$el.classList.add("v_select_invalid")
		}
		else if (this.$attrs.state === null || this.$attrs.state === true)
		{
			this.$el.classList.remove("v_select_invalid")
		}

		this.$on("open", () => { this.$el.querySelector(".vs__search").classList.remove("v_select_not_input") })
		this.$on("close", () => { this.$el.querySelector(".vs__search").classList.add("v_select_not_input") })

		this.$refs.clearButton.title = "Очистить"
		this.$slots["no-options"] = "Ничего не найдено"
	},

	updated()
	{
		if (this.$attrs.state === false)
		{
			this.$el.classList.add("v_select_invalid")
		}
		else if (this.$attrs.state === null || this.$attrs.state === true)
		{
			this.$el.classList.remove("v_select_invalid")
		}

		this.$refs.clearButton.title = "Очистить"
		this.$slots["no-options"] = "Ничего не найдено"
	}
}

vSelect.mixins.push(replace_no_options_mixin)
vSelect.directives.appendToBody = appendToBody

Vue.component("v-select", vSelect)

var b_tabs_mixin =
{
	mounted()
	{
		if (this.id != "cost_evaluation_setups" && this.id != "main_tree_groups")
		{
			const prefix = this.id == null ? "" : "_" + this.id
			const key = "current_tab_"
				+ window.location.pathname.replaceAll("/", "_")
				+ prefix
			const prev_title = api.storage.get(this, key, null, String)
			var get_tab_title =
				tab =>
				{
					const title = tab.id == null ? tab.title : tab.id
	
					return title
				}
	
			this.finding = true
	
			this.$on("activate-tab",
				ind =>
				{
					const title = get_tab_title(this.tabs[ind])
	
					api.storage.set(this, key, title)
					this.finding = false
				})
	
			if(prev_title != null)
				this.$on("changed",
					tabs =>
					{
						if(this.finding)
						{
							const ind = tabs.findIndex(tab => prev_title == get_tab_title(tab))
	
							if(ind >= 0)
							{
								this.currentTab = ind
								this.finding = false
							}
						}
					})
		}
	},
}

BTabs.mixin(b_tabs_mixin)

Vue.config.productionTip = false

new Vue(
{
	router,
	render: h => h(App),
}).$mount("#app")

